/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PlatFormAccountQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PlatFormAccountQueryOperator");
    }

    getFixupPrototypeFunction() { return PlatFormAccountQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PlatFormAccountQueryOperator>): PlatFormAccountQueryOperator {
        let obj = Object.assign(new PlatFormAccountQueryOperator(), model);
        PlatFormAccountQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PlatFormAccountQueryOperator>): PlatFormAccountQueryOperator {
        if (!model) return null;
        return PlatFormAccountQueryOperator.newInstance(<PlatFormAccountQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PlatFormAccountQueryOperator) {
        if (!obj) return;

        models.PlatFormAccountQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PlatFormAccountQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PlatFormAccountQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service type of the platform. Eg, kubernetes
     */
    service_type: string;

    /**
     * Cluster type of the platform. Eg, EKS, AKS and etc
     */
    cluster_type: string;

    /**
     * Platform account IDs to include
     */
    platform_account_ids: Array<string>;

}
